import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Counter2Component } from './counter2/counter2.component';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';

@NgModule({
  imports: [
    CommonModule, BrowserModule
  ],
  declarations: [Counter2Component],
   schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
     entryComponents : [
    Counter2Component
  ],
    providers: []
})
export class SecondoModule { constructor(private injector: Injector) {
    const el = createCustomElement(Counter2Component, {injector : this.injector});
    customElements.define('counter2-test', el);
  }

  ngDoBootstrap() {
   // const el = createCustomElement(CounterComponent, {injector : this.injector});
   // customElements.define('counter', el);
   }
}
